var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartIcon = function SvgHeartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 53 52"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#HeartIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25 33.62c.21 0 .512-.14.723-.27 5.696-3.587 9.252-7.826 9.252-12.105 0-3.556-2.442-6.067-5.696-6.067-1.868 0-3.375 1.105-4.279 2.803-.904-1.688-2.42-2.803-4.279-2.803-3.254 0-5.696 2.511-5.696 6.067 0 4.28 3.526 8.568 9.242 12.104.22.13.522.271.733.271"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.6,
    d: "m23.695 18.359.708 1.32.704-1.322c.797-1.498 2.063-2.379 3.572-2.379 2.774 0 4.896 2.113 4.896 5.267 0 3.837-3.225 7.868-8.875 11.425a1.7 1.7 0 0 1-.3.144l-.066-.024a2 2 0 0 1-.254-.126c-5.655-3.5-8.854-7.58-8.854-11.419 0-3.154 2.122-5.267 4.896-5.267 1.498 0 2.774.89 3.573 2.38Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "HeartIcon_svg__a",
    width: 56,
    height: 56,
    x: -1.4,
    y: -2.001,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.6,
    dy: 1.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1356_14226"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1356_14226",
    result: "shape"
  })))));
};
export default SvgHeartIcon;